import { useCallback, useState } from 'react';
import CustomConfirmModal from '@/components/Common/Modals/CustomConfirmModal';

type ConfirmState = {
  show: boolean;
  title: string;
  message: string;
  onConfirm: () => void;
};

export function useLocalConfirmModal() {
  const [confirmState, setConfirmState] = useState<ConfirmState>({
    show: false,
    title: '',
    message: '',
    onConfirm: () => {}
  });

  const openConfirm = useCallback(
    (title: string, message: string, onConfirm: () => void) => {
      setConfirmState({ show: true, title, message, onConfirm });
    },
    []
  );

  const ConfirmModalUI = (
    <CustomConfirmModal
      show={confirmState.show}
      setShow={show => setConfirmState(s => ({ ...s, show }))}
      data={{
        title: confirmState.title,
        message: confirmState.message,
        onClick: () => {
          confirmState.onConfirm();
          setConfirmState(s => ({ ...s, show: false }));
        }
      }}
    />
  );

  return { ConfirmModalUI, openConfirm } as const;
}
